"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionService = void 0;
const app_1 = require("app");
class SessionService {
    GetSessionId() {
        this.sessionId = this.sessionId || app_1.UtilService.newUUID();
        return this.sessionId;
    }
    setDataToStorage(key, value) {
        window.sessionStorage.setItem(key, value);
    }
    getDataFromStorage(key) {
        return window.sessionStorage.getItem(key);
    }
    removeDataFromStorage(key) {
        window.sessionStorage.removeItem(key);
    }
}
const service = new SessionService();
exports.SessionService = service;
